var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formatType === 'checkbox')?_c('span',[(!!_vm.value && _vm.value === '1')?_c('i',{staticClass:"fas fa-square-check text-primary check"}):_c('i',{staticClass:"fa-solid fa-square check uncheck"})]):_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }